export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20overhead%20flat%20lay%20composition%20of%20carefully%20arranged%20lifestyle%20items%20including%20a%20ceramic%20coffee%20cup%20on%20a%20saucer%2C%20a%20small%20terracotta%20potted%20succulent%2C%20minimal%20brass%20candle%20holder%2C%20linen%20napkin%20with%20subtle%20texture%2C%20and%20a%20leather%20bound%20notebook%2C%20on%20a%20warm%20cream%20textured%20surface%20with%20soft%20natural%20morning%20light%20streaming%20diagonally%2C%20calm%20serene%20atmosphere%2C%20neutral%20beige%20sand%20warm%20ivory%20and%20soft%20sage%20green%20palette%2C%20editorial%20lifestyle%20photography%2C%20refined%20minimalist%20aesthetic%20with%20organic%20touches%2C%20breathing%20room%20with%20artistic%20negative%20space&width=1600&height=800&seq=cta-bg-v2-09&orientation=landscape"
          alt="Elegant lifestyle flat lay background"
          title="Kakobuy Spreadsheet - Discover Your Next Find"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-500/50 via-primary-500/40 to-primary-500/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 leading-tight">
            Ready to{" "}
            <span className="italic text-accent-400">
              Discover Your Next Find
            </span>
            ?
          </h2>
          <p className="text-base md:text-lg text-background-50/80 mb-10 leading-relaxed">
            Explore the curated Kakobuy Spreadsheet with hundreds of trending products across 14 categories. Find fashion, sneakers, accessories, and more — all organized and updated daily.
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-4 px-8 py-4 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            <span className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
              <i className="ri-shopping-bag-line text-background-50 text-lg"></i>
            </span>
            <span className="font-label text-base font-semibold tracking-wide whitespace-nowrap">
              SHOP ON KAKOBUY SHEET
            </span>
            <i className="ri-arrow-right-up-line text-background-50 text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}